import { getUserCookie } from './cookieToken'

// Returns the session-info cookie fields (userId, userRole, tokenExpiry).
// These are plain non-secret values used for UI purposes only.
// The cookie is stored as plain JSON, so no decryption is performed here.
// Authentication is handled by the HttpOnly auth token cookie set by the backend.
export const getUserSessionData = () => {
  const data = getUserCookie()
  if (!data) return null

  return {
    ...data,
    userId: data.userId ?? '',
    userRole: data.userRole ?? '',
  }
}
